import React from "react";
import { Card, Typography, CardContent, CardMedia } from "@material-ui/core";
import "./Cardash.css";

import { makeStyles } from "@material-ui/core/styles";

function Cardash(props) {
  const useStyles = makeStyles(() => ({
    
    texto: {
      fontSize: 18,

      color: props.font,
    },
    titulo: {
      fontWeight: "bold",
      margin: "0.2rem",
      fontSize: 22,
      color: props.font,
    },
    button: {
      fontWeight: "bold",
      margin: "0.2rem",
      fontSize: 14,
      color: "#fffff",
    },
  }));

  const classes = useStyles();
  return (
    <Card
      className="text-center mt-10 rounded-md h-48"
      // style={`background-color: ${props.color};`}
      
   
    >
      <a className="btn14 btn border-0"  href={props.onClick ? props.onClick : "#!"}>
        <CardContent className="flex gap-4 justify-center items-center">
          <div className="imageCard">
            <CardMedia className="w-48 h-32 rounded-full"
              component="img"
              image={props.imagen}
            />
          </div>
          <div
            className="content"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <h3 className='text-2xl font-bold'>{props.titulo}</h3>

            <h4 className='text-lg font-light text-black'>{props.texto}</h4>
         
          </div>
        </CardContent>
      </a>
    </Card>
  );
}

export default Cardash;
